import { Outlet } from 'react-router-dom';
import { GlobalTopNav } from '@/components/GlobalTopNav';

export function Layout() {
  return (
    <div className="h-screen flex overflow-hidden bg-[#f8fafc] text-[#111827]">
      <div className="flex-1 min-w-0 flex flex-col">
        <GlobalTopNav />
        <main className="relative flex-1 overflow-auto bg-[#f1f5f9]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
